// extracted by mini-css-extract-plugin
export default {"inputmessage":"messageInput_inputmessage__vbphm","iconClick":"messageInput_iconClick__1zkZO","voiceIcon":"messageInput_voiceIcon__hs5Mr"};